import { render, staticRenderFns } from "./ManualWeb.vue?vue&type=template&id=8013ac48&scoped=true"
import script from "./ManualWeb.vue?vue&type=script&lang=js"
export * from "./ManualWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8013ac48",
  null
  
)

export default component.exports